import { useEffect, useState } from 'react';

/**
 * A value that lags behind by `delay`, so a search box does not fire a request per key.
 *
 * Typing "ferreteria" used to be ten `GET /api/clients`, each one a new React Query key
 * and a new row in somebody's access log. The lag is only on what is *sent*: the input
 * itself stays instant, because a text box that stutters is worse than a slow answer.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [lagging, setLagging] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setLagging(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return lagging;
}
